







import Vue from 'vue';

import DollarPresenter from '@/components/Misc/DollarPresenter.vue';

export default Vue.extend({
  components: {
    DollarPresenter,
  },
  props: [
    // 'priceCurrency',
    'sellingPrice',
    // 'primeCostCurrency',
    'primeCost',
    'primeCostAdjust',
    'isHiddenPrice',
  ],
});
